<template>
  <div class="wrap">
    <div class="title">松鼠杯日报</div>
    <div class="daily-date">
      <span>{{ dailyDate }}</span
      ><img
        @click="calendarIsShow"
        src="../../assets/images/winterGame/calendarGrayIcon.png"
      />
    </div>
    <div class="tab">
      <van-tabs
        v-model="activeName"
        @change="changeTab"
        color="#4B8AFE"
        line-width="20"
        title-inactive-color="#999999"
      >
        <van-tab
          v-for="(nav, index) in navList"
          :key="nav.id"
          :title="nav.showTitle"
          :name="nav.type"
        >
          <div v-if="nav.type == 'trainingGround'" class="tabSty">
            <div :class="{ ctiveSty: tabActive === 3 }" @click="checkTab(3)">
              自动匹配
            </div>
            <div :class="{ ctiveSty: tabActive === 4 }" @click="checkTab(4)">
              面对面
            </div>
          </div>

          <div class="my-table">
              <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="tableData.length> 0 ?'没有更多了' : '暂无数据'"
                :immediate-check="false"
                :offset="2"
                @load="onLoad"
              >
                <myTable
                  v-if="nav.type == navList[index].type"
                  :tableColumn="tableColumn"
                  :tableData="tableData"
                  headerBg="#d8ebfc"
                >
                  <template v-slot:slot="currentRow">
                    <div id="fiveSix" class="poster" @click="handlePoster(currentRow)">
                      查看海报
                    </div>
                  </template>
                  <template v-slot:nameOp="currentRow">
                    <div @click="handlePoster(currentRow)">
                      {{
                        currentRow.currentRow.uname ||
                        currentRow.currentRow.phone ||
                        ""
                      }}
                    </div>
                  </template>
                </myTable>
              </van-list>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 海报 -->
    <div class="poster-wrap">
      <poster
        :posterUrl="posterObj.posterUrl"
        :isShow="posterObj.isShow"
        @OnCancelPoster="handleCancelPoster"
      >
        <div class="poster" id="container" v-if="posterObj.isShow">
          <img :src="fiveHurdlesPoster" />
          <div class="poster-info">
            <div class="dateSty center">{{ bannerObj.copyDate }}</div>
            <div class="service center">{{ bannerObj.service_name }}</div>
            <div class="student-name center">{{ bannerObj.real_name }}</div>
            <div class="desc center">挑战{{ bannerObj.boss_cnt }}个BOSS</div>
            <div class="subject-name center" :style="{ backgroundImage: subjectNameBg ? `url(${subjectNameBg}) no-repeat center center / 100% 100%` : '' }">{{ bannerObj.subject_text }}</div>
            <div class="details">
              <div>
                <span>{{ bannerObj.study_time_length }}</span
                >分钟
              </div>
              <div>
                <span>{{ bannerObj.ques_cnt }}</span
                >题
              </div>
              <div>
                <span>{{ bannerObj.vide_time_length }}</span
                >分钟
              </div>
            </div>
          </div>
        </div>
      </poster>
    </div>

    <!-- 日历组件 -->
    <div class="calendar">
      <van-calendar
        :default-date="defaultDate"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="isCalendarShow"
        @confirm="onConfirm"
      />
    </div>
  </div>
</template>

<script>
import { Toast, List, Cell } from "vant";
import html2canvas from "html2canvas";
import { format } from "@/util/util";
import myTable from "./components/myTable.vue";
import Empty from "./components/Empty.vue";
import poster from "./components/poster.vue";
import {
  dailypkreport,
  everydayserviceuserstatistics,
} from "@/api/squirrelCup";
import {
  queryseasonconfigbyseasonid
} from "@/api/winterGame";

export default {
  data() {
    return {
      posterObj: {
        isShow: false,
        isPoster: 1,
        posterUrl: "",
      },
      bannerObj: {}, // 海报详情
      activeName: "passFiveAndSix", //通过名称匹配tab
      tabActive: 3,
      loading: false,
      finished: false,
      rowInfos: [],
      page: {
        pageIndex: 0,
        pageSize: 10,
      },
      total: "",
      navList: [
        {
          id: 1,
          type: "PKMode",
          showTitle: "PK模式",
          list_type: 1
        },
        {
          id: 5,
          type: "fastPKMode",
          showTitle: "快速PK",
          list_type: 6
        },
        {
          id: 2,
          type: "singleMode",
          showTitle: "单人模式",
          list_type: 2
        },
        {
          id: 3,
          type: "passFiveAndSix",
          showTitle: "过五关斩六将",
        },
        {
          id: 4,
          type: "trainingGround",
          showTitle: "训练场",
          list_type: 3
        },
      ],
      tableColumn: [],
      tableData: [],
      PKModeList: [
        {
          label: "姓名",
          prop: "account_name",
          width: 150,
          nameOp: true,
        },
        {
          label: "学科",
          prop: "subject_text",
        },
        {
          label: "局数",
          prop: "pk_count",
        },
        {
          label: "奖杯数",
          prop: "score",
        },
        {
          label: "胜负平",
          prop: "result",
        },
      ],
      fastPKModeList: [
        {
          label: "姓名",
          prop: "account_name",
          width: 150,
          nameOp: true,
        },
        {
          label: "学科",
          prop: "subject_text",
        },
        {
          label: "局数",
          prop: "pk_count",
        },
        {
          label: "奖杯数",
          prop: "score",
        },
        {
          label: "胜负平",
          prop: "result",
        },
      ],
      PKModeData: [
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
      ],
      singleModeList: [
        {
          label: "姓名",
          prop: "account_name",
          width: 150,
          nameOp: true,
        },
        {
          label: "学科",
          prop: "subject_text",
        },
        {
          label: "局数",
          prop: "pk_count",
        },
        {
          label: "奖杯数",
          prop: "score",
        },
      ],
      singleModeData: [
        {
          name: "3",
          round: "3",
          cup: 5,
        },
        {
          name: "3",
          round: "3",
          cup: 5,
        },
        {
          name: "3",
          round: "3",
          cup: 5,
        },
        {
          name: "3",
          round: "3",
          cup: 5,
        },
      ],
      passFiveAndSixList: [
        {
          label: "姓名",
          prop: "real_name",
          nameOp: true,
          width: 150,
        },
        {
          label: "学科",
          prop: "subject_text",
        },
        {
          label: "已完成",
          prop: "finish_cnt",
          isSelect: true,
        },
        {
          label: "奖杯数（已完成）",
          prop: "score",
          width: 150,

          classBar: "fontSty",
          operation: true,
          html: () => {
            return `<div style=" display: flex;flex-direction:column">奖杯数<span style="font-size: 12px">（已完成）</span></div>`;
          },
        },
      ],
      passFiveAndSixData: [
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
      ],
      trainingGroundList: [
        {
          label: "姓名",
          prop: "account_name",
          width: 150,
          nameOp: true,
        },
        {
          label: "学科",
          prop: "subject_text",
        },
        {
          label: "局数",
          prop: "pk_count",
        },
        {
          label: "奖杯数",
          prop: "score",
        },
        {
          label: "胜负平",
          prop: "result",
          width: 100,
        },
      ],
      trainingGroundData: [
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
        {
          name: "3",
          round: "3",
          cup: 5,
          win: "胜",
        },
      ],
      teamCompetitionList: [
        {
          label: "姓名",
          prop: "account_name",
          width: 150,
          nameOp: true,
        },
        {
          label: "学科",
          prop: "subject_text",
        },
        {
          label: "局数",
          prop: "pk_count",
        },
        {
          label: "奖杯数",
          prop: "score",
        },
        {
          label: "胜负平",
          prop: "result",
          width: 100,
        },
      ],
      teamCompetitionData: [
        
      ],
      tabType: null, // 当前tab选项下标
      defaultDate: new Date(),
      minDate: new Date(2024, 3, 29),
      maxDate: new Date(),
      isCalendarShow: false,
      dailyDate: "",
      fiveHurdlesPoster: '', // 过五关斩六将海报
      subjectNameBg: '', // 学科名称背景
    };
  },
  components: {
    myTable,
    poster,
    Empty,
    [List.name]: List,
    [Cell.name]: Cell,
  },
  created() {
    document.title = this.$route.meta.title || "松鼠杯日报";
    this.tableColumn = this.passFiveAndSixList;
    const { payStatus } = JSON.parse(localStorage.getItem('teamInfo'));
    if (payStatus == 1) {
      this.navList.unshift(
        {
          id: 6,
          type: "teamCompetition",
          showTitle: "团队赛",
          list_type: 5
        }
      )
    }
  },
  mounted() {
    this.dailyDate = format(new Date());
    this.queryConfig();
    this.onLoad();
  },
  methods: {
    handlePoster(item) {
      console.log(item);
      this.bannerObj = item.currentRow;
      const [year, month, day] = this.dailyDate.split("-");
      const strDate = `${month}月${day}日`;
      this.bannerObj.copyDate = strDate;
      console.log("查看海报", item);
      this.posterObj.isShow = true;
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      setTimeout(() => {
        const targetDom = document.querySelector("#container");
        console.log("targetDom", targetDom);
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.posterObj.isShow = true;
          this.posterObj.posterUrl = canvas.toDataURL();
          this.posterObj.isPoster = -1;
          Toast('长按保存图片');
        });
      }, 500);
    },
    handleCancelPoster() {
      this.posterObj.isShow = false;
      this.$toast.clear(); // 清除当前 Toast
    },
    changeTab(item) {
      this.tableColumn = this[item + "List"];
      this.page.pageIndex = 0;
      this.finished = false;
      this.tableData = [];
      this.navList.map(el => {
        if (el.type == item) {
          this.tabType = el.list_type;
        }
      })
      this.onLoad();
    },
    checkTab(val) {
      this.tabActive = val;
      this.tabType = val;
      this.page.pageIndex = 0;
      this.finished = false;
      this.tableData = [];
      this.onLoad(val);
    },
    calendarIsShow() {
      this.isCalendarShow = true;
    },
    onConfirm(date) {
      this.isCalendarShow = false;
      this.dailyDate = format(date);
      this.changeTab(this.activeName);
      console.log(this.dailyDate);
    },
    queryConfig() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams")) || {};
      let paramData = {
        param: {
          seasonTagId: pkParams.seasonId
        },
      };
      queryseasonconfigbyseasonid(paramData).then(res => {
        if (res.code == 0) {
          const { fiveHurdlesPoster, digitalBgCut } =  res.data;
          this.fiveHurdlesPoster = fiveHurdlesPoster;
          console.log("digitalBgCut", digitalBgCut);
          console.log("digitalBgCut type:", typeof digitalBgCut);
          console.log("digitalBgCut length:", digitalBgCut ? digitalBgCut.length : 'null/undefined');
          this.subjectNameBg = digitalBgCut;
        } else {
          Toast(res.message);
        }
      })
    },
    getDailypkreport(type) {
      this.finished = true;

      let pkParams = JSON.parse(localStorage.getItem("pkParams")) || {};
      let userInfo = JSON.parse(localStorage.getItem("userInfoId")) || {};

      let paramData = {
        param: {
          season_id: pkParams.seasonId,
          agent_id: Number(userInfo.campusId),
          date: this.dailyDate + " 00:00:00",
          list_type: type, //1个人 2单人 3自匹 4面对面
        },
        ...this.page,
      };
      dailypkreport(paramData).then((res) => {
        if (res.code === 0) {
          this.finished = false;
          this.total = res.data.count;
          this.tableData = this.tableData.concat(res.data.list);
        }
        this.loading = false;
        // if (res.data.body.length  < 10) return (this.finished = true);
        if (this.tableData.length >= this.total) return (this.finished = true);
      });
    },
    getTabinfo() {
      this.finished = true;
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      // let userInfo = JSON.parse(localStorage.getItem("userInfoId"));
      let teamInfo = JSON.parse(localStorage.getItem("teamInfo"));
      const str = this.dailyDate.split("-").join("");
      let paramData = {
        param: {
          season_id: teamInfo.seasonId,
          service_id: Number(pkParams.currentCampusId),
          ymd: str,
        },
        ...this.page,
      };
      everydayserviceuserstatistics(paramData).then((res) => {
        if (res.code === 0) {
          this.finished = false;

          this.total = res.data.count;
          this.tableData = this.tableData.concat(res.data.list);
        }
        this.loading = false;
        if (this.tableData.length >= this.total) return (this.finished = true);
      });
    },
    onLoad(idx) {
      if (this.finished) return;
      console.log(this.activeName, "onload+++");
      this.page.pageIndex++;
      if (this.activeName == "passFiveAndSix") {
        this.getTabinfo();
      } else {
        this.getDailypkreport(this.tabType);
      }
    },
  },
};
</script>
<style scoped lang="less">
.wrap {
  position: relative;
  padding-top: 48px;
  overflow: hidden;
  .title {
    font-size: 40px;
    font-weight: 800;
    text-align: center;
  }
  .daily-date {
    margin: 8px 0 28px;
    font-size: 28px;
    color: #68707d;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 30px;
      height: 30px;
      margin-left: 8px;
    }
  }
  .tab {
    /deep/.van-tabs__wrap {
      overflow-x: auto;
      padding-bottom: 20px;
      .van-tab {
        min-width: 200px;
      }
    }
    .my-table {
      margin-top: 40px;
      height: calc(100vh - 310px);
      overflow: auto;
      .poster {
        width: 64px;
        height: 80px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #58abf6;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-decoration-line: underline;
        margin-left: 20px;
        margin-right: 50px;
      }
    }
    .tabSty {
      display: flex;
      justify-content: center;
      font-size: 28px;
      color: #323232;
      margin-top: 20px;
      div {
        width: 176px;
        height: 56px;
        background: #f6f9fd;
        border-radius: 28px;
        text-align: center;
        line-height: 56px;
        margin-left: 32px;
      }
      .ctiveSty {
        background: #58abf6;
        color: #ffffff;
        font-weight: bold;
      }
    }
  }

  .poster-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    #container {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
    }
    .poster {
      position: relative;
      width: 100%;
      z-index: 100;
      text-align: center;
      background: rgba(0, 0, 0, 0.7);
      // background: url("../../../assets/images/squirrelCup/2024/cupTwo/banner@2x.png") no-repeat;
      // background-size: contain;
      img {
        width: 100%;
        height: 100%;
      }
      .poster-info {
        position: absolute;
        top: 0;
        width: 100%;
        .center {
          position: absolute;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: PingFangSC, PingFang SC;
          font-style: normal;
          white-space: nowrap;
        }
        .service,
        .dateSty {
          top: 430px;
          font-weight: 500;
          font-size: 32px;
          color: #ffffff;
        }
        .dateSty {
          top: 305px;
        }
        .student-name {
          top: 500px;
          font-weight: 600;
          font-size: 56px;
          color: #ffffff;
          text-shadow: 0px 4px 16px rgba(9, 0, 78, 0.77);
        }
        .desc {
          top: 800px;
          font-weight: 600;
          font-size: 48px;
          color: #6dfffd;
        }
        .subject-name {
          width: 402px;
          height: 82px;
          /* fallback background image */
          background: url('../../assets/images/squirrelCup/2024/cupTwo/subject_bg.png') no-repeat center center;
          background-size: 100% 100%;
          top: 900px;
          font-weight: 600;
          font-size: 48px;
          color: #6dfffd;
          line-height: 82px;
        }
        .details {
          position: absolute;
          top: 1100px;
          width: 100%;
          padding: 0 36px;
          display: flex;
          font-family: PingFangSC, PingFang SC;
          color: #bdffbb;
          line-height: 60px;
          div {
            width: 33.33%;
            font-weight: 500;
            font-size: 32px;
            span {
              display: block;
              font-weight: 600;
              font-size: 56px;
            }
          }
        }
      }
    }
  }
}
</style>
